export function farloUiPodcastSlider(element) {
    const carouselElement = document.querySelector('.cards-slider__enable');
    if (carouselElement) {
        // Step 1: Clean Up Pre-existing Flickity Classes
        carouselElement.classList.remove('flickity-enabled', 'is-draggable');

        // Step 2: Remove 'is-selected' from all cells
        const cells = carouselElement.querySelectorAll('.flickity-cell');
        cells.forEach(cell => cell.classList.remove('is-selected'));

        // Step 3: Define Media Query
        //const mediaQuery = window.matchMedia('(max-width: 980px)');

        // Step 4: Initialize Flickity after Images Load
        imagesLoaded(carouselElement, () => {
            handleResize();
        });

        // Step 5: Handle Window Resize with Debounce
        let resizeTimeout;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(() => {
                handleResize();
            }, 150);
        });

        // Function to Initialize Flickity
        function initializeFlickity() {
            flkty = new Flickity(carouselElement, {
                cellAlign: 'left',
                contain: true,
                pageDots: false,
                prevNextButtons: true,
                wrapAround: false,
                groupCells: false,
                freeScroll: true,
                draggable: true,
                scrollSnap: true,
                adaptiveHeight: false,
                // arrowShape: {
                //     x0: 0,
                //     x1: 80, y1: 45,
                //     x2: 80, y2: 25,
                //     x3: 35
                // },
            });

            // Listen to Flickity events for debugging
            flkty.on('ready', () => {
                flkty.resize();
            });

            // Force Flickity to recalculate layout after a short delay
            setTimeout(() => {
                flkty.resize();
            }, 100); // Adjust the delay as necessary



        }

        // Function to Handle Resize and Initialize/Destroy Flickity Accordingly
        function handleResize() {

            initializeFlickity();
        }


    }
}
